export default __webpack_public_path__ + "static/pay-it-faster-video-thumbnail-1c7e3fb5312a20ead5875822a48f2363.png";